// // // import { useLocation } from "react-router-dom";
// // // import ContactSection from "../components/ContactForm";
// // // import Footer from "../components/Footer";
// // // import Header from "../components/Header";
// // // import HeroSection from "../components/HeroSection";
// // // import HeroSection2 from "../components/HeroSection2";
// // // import ServicesSection from "../components/Services";
// // // import { useEffect } from "react";

// // // export default function HomePage () {
// // //    const { pathname } = useLocation();
// // //    useEffect(() => {
// // //      window.scrollTo(0, 0);
// // //    }, [pathname]);

// // //    return(
// // //     <div className="font-body">
// // //     <Header />
// // //       <HeroSection />
// // //       <HeroSection2 />
// // //       <ServicesSection />
// // //       <ContactSection />
// // //       <Footer />
// // //   </div>
// // //    )
  
// // // }

// // import React, { useState } from 'react';

// // const HomePage = () => {
// //   const [activeTab, setActiveTab] = useState('home');
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
  
// //   // Animation for numbers
// //   const [isVisible, setIsVisible] = useState(false);
  
// //   setTimeout(() => {
// //     setIsVisible(true);
// //   }, 500);

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 text-gray-800 font-sans">
// //       {/* Navbar */}
// //       <nav className="bg-white shadow-md px-4 py-4 lg:py-6 flex justify-between items-center relative z-10">
// //         <div className="flex items-center space-x-2">
// //           <div className="h-8 w-8 bg-teal-500 rounded-full flex items-center justify-center">
// //             <span className="text-white font-bold">CA</span>
// //           </div>
// //           <span className="text-xl font-bold text-teal-800">Precision</span>
// //           <span className="text-xl font-light text-gray-600">Accounts</span>
// //         </div>
        
// //         {/* Desktop Menu */}
// //         <div className="hidden lg:flex space-x-8">
// //           {['Home', 'Services', 'About', 'Testimonials', 'Contact'].map((item) => (
// //             <button 
// //               key={item} 
// //               className={`font-medium transition-all duration-300 ${
// //                 activeTab.toLowerCase() === item.toLowerCase() 
// //                   ? 'text-teal-600 border-b-2 border-teal-600' 
// //                   : 'text-gray-600 hover:text-teal-600'
// //               }`}
// //               onClick={() => setActiveTab(item.toLowerCase())}
// //             >
// //               {item}
// //             </button>
// //           ))}
// //         </div>
        
// //         {/* Mobile Menu Button */}
// //         <button 
// //           className="lg:hidden text-gray-600"
// //           onClick={() => setIsMenuOpen(!isMenuOpen)}
// //         >
// //           <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// //           </svg>
// //         </button>
// //       </nav>
      
// //       {/* Mobile Menu */}
// //       {isMenuOpen && (
// //         <div className="lg:hidden bg-white shadow-lg py-4 px-6 absolute w-full z-20">
// //           {['Home', 'Services', 'About', 'Testimonials', 'Contact'].map((item) => (
// //             <button 
// //               key={item} 
// //               className={`block w-full text-left py-2 font-medium ${
// //                 activeTab.toLowerCase() === item.toLowerCase() 
// //                   ? 'text-teal-600' 
// //                   : 'text-gray-600'
// //               }`}
// //               onClick={() => {
// //                 setActiveTab(item.toLowerCase());
// //                 setIsMenuOpen(false);
// //               }}
// //             >
// //               {item}
// //             </button>
// //           ))}
// //         </div>
// //       )}
      
// //       {/* Content based on active tab */}
// //       <div className="container mx-auto px-4 py-12">
// //         {activeTab === 'home' && (
// //           <div className="flex flex-col lg:flex-row items-center">
// //             <div className="lg:w-1/2 mb-8 lg:mb-0 lg:pr-12">
// //               <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
// //                 Financial clarity for your <span className="text-teal-600">future</span>
// //               </h1>
// //               <p className="text-lg text-gray-600 mb-6">
// //                 Precision Accounts provides expert financial guidance with a personal touch.
// //                 Let us handle the numbers while you focus on your growth.
// //               </p>
// //               <div className="flex flex-col sm:flex-row gap-4">
// //                 <button className="bg-teal-600 hover:bg-teal-700 transition-colors text-white font-medium py-3 px-6 rounded-lg shadow-lg hover:shadow-xl">
// //                   Book a Consultation
// //                 </button>
// //                 <button className="border border-teal-600 text-teal-600 hover:bg-teal-50 transition-colors font-medium py-3 px-6 rounded-lg">
// //                   View Services
// //                 </button>
// //               </div>
// //             </div>
// //             <div className="lg:w-1/2 relative">
// //               <div className="absolute -top-6 -left-6 h-24 w-24 bg-yellow-200 rounded-full opacity-60"></div>
// //               <div className="absolute -bottom-6 -right-6 h-32 w-32 bg-teal-200 rounded-full opacity-60"></div>
// //               <div className="rounded-2xl shadow-2xl bg-white p-6 lg:p-8 relative z-0 transform transition-all hover:-translate-y-2">
// //                 <div className="grid grid-cols-2 gap-4">
// //                   <div className={`transition-all duration-700 ease-in-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
// //                     <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-teal-400">
// //                       <p className="text-4xl font-bold text-teal-600">98%</p>
// //                       <p className="text-gray-600">Client retention</p>
// //                     </div>
// //                   </div>
// //                   <div className={`transition-all duration-700 ease-in-out delay-100 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
// //                     <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-purple-400">
// //                       <p className="text-4xl font-bold text-purple-600">15+</p>
// //                       <p className="text-gray-600">Years experience</p>
// //                     </div>
// //                   </div>
// //                   <div className={`transition-all duration-700 ease-in-out delay-200 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
// //                     <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-yellow-400">
// //                       <p className="text-4xl font-bold text-yellow-600">$42M</p>
// //                       <p className="text-gray-600">Tax savings</p>
// //                     </div>
// //                   </div>
// //                   <div className={`transition-all duration-700 ease-in-out delay-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
// //                     <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-indigo-400">
// //                       <p className="text-4xl font-bold text-indigo-600">350+</p>
// //                       <p className="text-gray-600">Businesses served</p>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         )}
        
// //         {activeTab === 'services' && (
// //           <div>
// //             <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
// //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //               {[
// //                 {
// //                   title: 'Tax Planning',
// //                   icon: '📊',
// //                   description: 'Strategic tax planning to minimize liabilities and ensure compliance with the latest regulations.'
// //                 },
// //                 {
// //                   title: 'Business Accounting',
// //                   icon: '💼',
// //                   description: 'Comprehensive bookkeeping and accounting services tailored to your business needs.'
// //                 },
// //                 {
// //                   title: 'Financial Advisory',
// //                   icon: '📈',
// //                   description: 'Expert financial guidance to help you make informed decisions for sustainable growth.'
// //                 },
// //                 {
// //                   title: 'Audit Services',
// //                   icon: '🔍',
// //                   description: 'Thorough audit services to ensure financial accuracy and regulatory compliance.'
// //                 },
// //                 {
// //                   title: 'Estate Planning',
// //                   icon: '📝',
// //                   description: 'Thoughtful estate planning to protect your assets and secure your legacy.'
// //                 },
// //                 {
// //                   title: 'CFO Services',
// //                   icon: '👔',
// //                   description: 'Part-time CFO services providing strategic financial leadership for growing businesses.'
// //                 }
// //               ].map((service, index) => (
// //                 <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6 border-t-4 border-teal-500">
// //                   <div className="text-4xl mb-4">{service.icon}</div>
// //                   <h3 className="text-xl font-bold mb-2 text-gray-800">{service.title}</h3>
// //                   <p className="text-gray-600">{service.description}</p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         )}
        
// //         {activeTab === 'about' && (
// //           <div className="max-w-4xl mx-auto">
// //             <h2 className="text-3xl font-bold text-center mb-8">About Precision Accounts</h2>
// //             <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8 mb-8">
// //               <p className="text-lg text-gray-700 mb-6">
// //                 Founded in 2010, Precision Accounts has been helping businesses and individuals navigate the complex world of finance with clarity and confidence. Our team of certified accountants brings decades of combined experience across various industries.
// //               </p>
// //               <p className="text-lg text-gray-700 mb-6">
// //                 What sets us apart is our commitment to building lasting relationships. We don't just work for you—we work with you, taking the time to understand your unique goals and challenges.
// //               </p>
// //               <div className="border-l-4 border-teal-500 pl-4 italic text-gray-600">
// //                 "Our mission is to demystify finance and empower our clients to make confident decisions that drive success and create lasting value."
// //               </div>
// //             </div>
            
// //             <h3 className="text-2xl font-bold mb-6">Meet Our Team</h3>
// //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// //               {[
// //                 { name: 'Sarah Chen', role: 'Founder & Principal', image: '/api/placeholder/200/200' },
// //                 { name: 'Miguel Rodriguez', role: 'Tax Specialist', image: '/api/placeholder/200/200' },
// //                 { name: 'Aisha Patel', role: 'Business Advisor', image: '/api/placeholder/200/200' }
// //               ].map((member, index) => (
// //                 <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center">
// //                   <img 
// //                     src={member.image} 
// //                     alt={member.name} 
// //                     className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
// //                   />
// //                   <h4 className="text-xl font-bold text-gray-800">{member.name}</h4>
// //                   <p className="text-teal-600">{member.role}</p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         )}
        
// //         {activeTab === 'testimonials' && (
// //           <div>
// //             <h2 className="text-3xl font-bold text-center mb-12">What Our Clients Say</h2>
// //             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
// //               {[
// //                 {
// //                   quote: "Precision Accounts transformed our financial operations. Their strategic tax planning saved us over $50,000 last year alone.",
// //                   author: "James Wilson",
// //                   company: "Horizon Tech Solutions",
// //                   rating: 5
// //                 },
// //                 {
// //                   quote: "Working with the team at Precision has given me peace of mind knowing my finances are in expert hands. They're responsive, thorough, and genuinely care.",
// //                   author: "Elena Martinez",
// //                   company: "Craft & Bloom",
// //                   rating: 5
// //                 },
// //                 {
// //                   quote: "As a startup founder, I needed financial guidance that could scale with my business. Precision Accounts has been the perfect partner for that journey.",
// //                   author: "Alex Johnson",
// //                   company: "NovaSpark Innovations",
// //                   rating: 5
// //                 },
// //                 {
// //                   quote: "Their attention to detail is remarkable. They caught several opportunities for tax savings that our previous accountant had missed for years.",
// //                   author: "Sophia Lee",
// //                   company: "Evergreen Properties",
// //                   rating: 5
// //                 }
// //               ].map((testimonial, index) => (
// //                 <div key={index} className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-teal-500 relative">
// //                   <div className="absolute -top-3 -left-3 bg-teal-500 text-white h-8 w-8 rounded-full flex items-center justify-center">
// //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
// //                       <path fillRule="evenodd" d="M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z" clipRule="evenodd" />
// //                     </svg>
// //                   </div>
// //                   <p className="italic text-gray-700 mb-4">{testimonial.quote}</p>
// //                   <div className="flex justify-between items-center">
// //                     <div>
// //                       <p className="font-bold text-gray-800">{testimonial.author}</p>
// //                       <p className="text-sm text-gray-600">{testimonial.company}</p>
// //                     </div>
// //                     <div className="flex">
// //                       {[...Array(testimonial.rating)].map((_, i) => (
// //                         <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
// //                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
// //                         </svg>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         )}
        
// //         {activeTab === 'contact' && (
// //           <div className="max-w-4xl mx-auto">
// //             <h2 className="text-3xl font-bold text-center mb-8">Get In Touch</h2>
// //             <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
// //               <div className="grid grid-cols-1 lg:grid-cols-2">
// //                 <div className="p-8 bg-teal-700 text-white">
// //                   <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
// //                   <div className="space-y-6">
// //                     <div className="flex items-start space-x-4">
// //                       <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
// //                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
// //                       </svg>
// //                       <div>
// //                         <p className="font-medium">Our Office</p>
// //                         <p className="text-teal-100">123 Financial District</p>
// //                         <p className="text-teal-100">Suite 400</p>
// //                         <p className="text-teal-100">San Francisco, CA 94111</p>
// //                       </div>
// //                     </div>
                    
// //                     <div className="flex items-start space-x-4">
// //                       <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
// //                       </svg>
// //                       <div>
// //                         <p className="font-medium">Phone</p>
// //                         <p className="text-teal-100">(555) 123-4567</p>
// //                       </div>
// //                     </div>
                    
// //                     <div className="flex items-start space-x-4">
// //                       <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
// //                       </svg>
// //                       <div>
// //                         <p className="font-medium">Email</p>
// //                         <p className="text-teal-100">info@precisionaccounts.com</p>
// //                       </div>
// //                     </div>
                    
// //                     <div className="pt-6">
// //                       <p className="font-medium mb-2">Office Hours</p>
// //                       <p className="text-teal-100">Monday - Friday: 9am - 5pm</p>
// //                       <p className="text-teal-100">Weekends: By appointment</p>
// //                     </div>
// //                   </div>
// //                 </div>
                
// //                 <div className="p-8">
// //                   <h3 className="text-2xl font-bold mb-6">Send us a message</h3>
// //                   <form className="space-y-4">
// //                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                       <div>
// //                         <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
// //                         <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" />
// //                       </div>
// //                       <div>
// //                         <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
// //                         <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" />
// //                       </div>
// //                     </div>
                    
// //                     <div>
// //                       <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
// //                       <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" />
// //                     </div>
                    
// //                     <div>
// //                       <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
// //                       <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" />
// //                     </div>
                    
// //                     <div>
// //                       <label className="block text-sm font-medium text-gray-700 mb-1">How can we help?</label>
// //                       <textarea rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"></textarea>
// //                     </div>
                    
// //                     <button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-4 rounded-lg transition-colors">
// //                       Send Message
// //                     </button>
// //                   </form>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //       </div>
// //   )
// // }

// // export default HomePage
      

// import React, { useState, useEffect } from 'react';

// const HomePage = () => {
//   const [currentSection, setCurrentSection] = useState('home');
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [darkMode, setDarkMode] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { id: 'home', label: 'Home' },
//     { id: 'services', label: 'Services' },
//     { id: 'about', label: 'About' },
//     { id: 'clients', label: 'Clients' },
//     { id: 'contact', label: 'Contact' }
//   ];

//   const toggleDarkMode = () => {
//     setDarkMode(!darkMode);
//   };

//   return (
//     <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-white text-gray-800'} transition-colors duration-300`}>
//       {/* Navbar */}
//       <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? (darkMode ? 'bg-gray-900/90 backdrop-blur-md' : 'bg-white/90 backdrop-blur-md shadow-md') : 'bg-transparent'}`}>
//         <div className="container mx-auto px-4 py-4 flex justify-between items-center">
//           <div className="flex items-center">
//             <div className={`mr-4 relative h-12 w-12 ${darkMode ? 'bg-purple-600' : 'bg-indigo-600'} rounded-full overflow-hidden transition-colors duration-300`}>
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <span className="text-white text-xl font-bold">CA</span>
//               </div>
//               <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-white/20"></div>
//             </div>
//             <div>
//               <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>Cipher</h1>
//               <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Accounting Solutions</p>
//             </div>
//           </div>
          
//           {/* Desktop Menu */}
//           <div className="hidden md:flex items-center space-x-1">
//             {navItems.map(item => (
//               <button
//                 key={item.id}
//                 onClick={() => setCurrentSection(item.id)}
//                 className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
//                   currentSection === item.id
//                     ? (darkMode ? 'bg-purple-600 text-white' : 'bg-indigo-600 text-white')
//                     : (darkMode ? 'text-gray-300 hover:bg-gray-800' : 'text-gray-700 hover:bg-gray-100')
//                 }`}
//               >
//                 {item.label}
//               </button>
//             ))}
//             <button
//               onClick={toggleDarkMode}
//               className={`ml-4 p-2 rounded-full ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-gray-100 text-gray-700'}`}
//             >
//               {darkMode ? (
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
//                 </svg>
//               ) : (
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                   <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
//                 </svg>
//               )}
//             </button>
//           </div>
          
//           {/* Mobile Menu Button */}
//           <div className="md:hidden flex items-center">
//             <button
//               onClick={toggleDarkMode}
//               className={`mr-2 p-2 rounded-full ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-gray-100 text-gray-700'}`}
//             >
//               {darkMode ? (
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
//                 </svg>
//               ) : (
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                   <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
//                 </svg>
//               )}
//             </button>
//             <button
//               onClick={() => setMenuOpen(!menuOpen)}
//               className={`p-2 rounded-lg ${darkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
//               </svg>
//             </button>
//           </div>
//         </div>
        
//         {/* Mobile Menu */}
//         {menuOpen && (
//           <div className={`md:hidden ${darkMode ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-100'} border-t`}>
//             {navItems.map(item => (
//               <button
//                 key={item.id}
//                 onClick={() => {
//                   setCurrentSection(item.id);
//                   setMenuOpen(false);
//                 }}
//                 className={`block w-full text-left px-4 py-3 ${
//                   currentSection === item.id
//                     ? (darkMode ? 'bg-purple-600 text-white' : 'bg-indigo-600 text-white')
//                     : (darkMode ? 'text-gray-300 hover:bg-gray-800' : 'text-gray-700 hover:bg-gray-100')
//                 }`}
//               >
//                 {item.label}
//               </button>
//             ))}
//           </div>
//         )}
//       </nav>
      
//       {/* Main Content */}
//       <main className="pt-24">
//         {/* HOME */}
//         {currentSection === 'home' && (
//           <section className="py-10">
//             <div className="container mx-auto px-4">
//               <div className="flex flex-col lg:flex-row items-center">
//                 <div className="lg:w-1/2 mb-10 lg:mb-0">
//                   <h1 className={`text-4xl lg:text-5xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
//                     Accounting beyond <span className={darkMode ? 'text-purple-500' : 'text-indigo-600'}>numbers</span>
//                   </h1>
//                   <p className={`text-lg mb-8 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                     We transform complex financial data into strategic insights that drive your business forward.
//                   </p>
//                   <div className="flex flex-wrap gap-4">
//                     <button className={`px-6 py-3 rounded-full font-medium ${darkMode ? 'bg-purple-600 hover:bg-purple-700' : 'bg-indigo-600 hover:bg-indigo-700'} text-white transition-colors duration-300`}>
//                       Get Started
//                     </button>
//                     <button className={`px-6 py-3 rounded-full font-medium ${darkMode ? 'bg-gray-800 text-white hover:bg-gray-700' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'} transition-colors duration-300`}>
//                       Learn More
//                     </button>
//                   </div>
//                 </div>
//                 <div className="lg:w-1/2 relative">
//                   <div className={`${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-3xl p-6 lg:p-8 relative overflow-hidden transition-colors duration-300`}>
//                     <div className={`absolute top-0 left-0 w-32 h-32 ${darkMode ? 'bg-purple-900/30' : 'bg-indigo-200/50'} rounded-full -translate-x-1/2 -translate-y-1/2 blur-xl`}></div>
//                     <div className={`absolute bottom-0 right-0 w-40 h-40 ${darkMode ? 'bg-purple-600/20' : 'bg-indigo-300/40'} rounded-full translate-x-1/4 translate-y-1/4 blur-xl`}></div>
//                     <div className="relative z-10">
//                       <div className="grid grid-cols-2 gap-4">
//                         {[
//                           { value: '98%', label: 'Client Retention', color: darkMode ? 'bg-purple-900/50' : 'bg-indigo-100' },
//                           { value: '15+', label: 'Years Experience', color: darkMode ? 'bg-purple-800/50' : 'bg-indigo-200' },
//                           { value: '300+', label: 'Clients Served', color: darkMode ? 'bg-purple-700/50' : 'bg-indigo-300' },
//                           { value: '42M+', label: 'Tax Savings', color: darkMode ? 'bg-purple-600/50' : 'bg-indigo-400' }
//                         ].map((stat, index) => (
//                           <div key={index} className={`${stat.color} ${darkMode ? 'text-white' : 'text-gray-800'} rounded-2xl p-4 backdrop-blur-sm transition-all duration-300 hover:scale-105`}>
//                             <p className="text-3xl font-bold">{stat.value}</p>
//                             <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>{stat.label}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
              
//               {/* Clients Strip */}
//               <div className={`mt-16 py-8 px-4 rounded-2xl ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} transition-colors duration-300`}>
//                 <p className={`text-center text-sm uppercase tracking-wider mb-6 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Trusted by industry leaders</p>
//                 <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
//                   {[1, 2, 3, 4, 5].map((_, index) => (
//                     <div key={index} className={`h-12 w-24 ${darkMode ? 'bg-gray-700' : 'bg-gray-200'} rounded-md flex items-center justify-center transition-colors duration-300`}>
//                       <span className={`font-bold ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>LOGO {index + 1}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </section>
//         )}
        
//         {/* SERVICES */}
//         {currentSection === 'services' && (
//           <section className="py-10">
//             <div className="container mx-auto px-4">
//               <div className="text-center mb-16">
//                 <h2 className={`text-3xl lg:text-4xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Our Services</h2>
//                 <p className={`max-w-2xl mx-auto ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                   Comprehensive financial solutions tailored to your unique needs
//                 </p>
//               </div>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {[
//                   {
//                     title: 'Tax Strategy',
//                     description: 'Optimize your tax position with forward-thinking strategies that align with your financial goals.',
//                     icon: '📊'
//                   },
//                   {
//                     title: 'Financial Advisory',
//                     description: 'Navigate complex financial decisions with expert guidance and data-driven insights.',
//                     icon: '💼'
//                   },
//                   {
//                     title: 'Wealth Management',
//                     description: 'Build and preserve your wealth with personalized investment and retirement strategies.',
//                     icon: '💰'
//                   },
//                   {
//                     title: 'Business Accounting',
//                     description: 'Streamline your financial operations with comprehensive accounting services.',
//                     icon: '📈'
//                   },
//                   {
//                     title: 'Risk Management',
//                     description: 'Identify and mitigate financial risks to protect your assets and business interests.',
//                     icon: '🛡️'
//                   },
//                   {
//                     title: 'Digital Transformation',
//                     description: 'Modernize your financial systems with cutting-edge technology solutions.',
//                     icon: '💻'
//                   }
//                 ].map((service, index) => (
//                   <div 
//                     key={index} 
//                     className={`group relative overflow-hidden rounded-2xl ${darkMode ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'} p-6 transition-all duration-300 shadow-lg hover:shadow-xl`}
//                   >
//                     <div className={`absolute -right-4 -top-4 w-24 h-24 rounded-full ${darkMode ? 'bg-purple-900/20' : 'bg-indigo-100/80'} blur-2xl group-hover:scale-150 transition-all duration-500`}></div>
//                     <div className="relative z-10">
//                       <span className="text-4xl mb-4 block">{service.icon}</span>
//                       <h3 className={`text-xl font-bold mb-3 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{service.title}</h3>
//                       <p className={`${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{service.description}</p>
//                       <button className={`mt-4 inline-flex items-center ${darkMode ? 'text-purple-400 hover:text-purple-300' : 'text-indigo-600 hover:text-indigo-700'} transition-colors duration-300`}>
//                         Learn more
//                         <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
//                           <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
//                         </svg>
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
              
//               <div className={`mt-16 p-8 rounded-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg transition-colors duration-300`}>
//                 <div className="flex flex-col md:flex-row items-center">
//                   <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
//                     <h3 className={`text-2xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Need a custom solution?</h3>
//                     <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                       Our team of experts can develop a tailored financial strategy that addresses your unique challenges and goals.
//                     </p>
//                   </div>
//                   <div className="md:w-1/3 flex justify-center md:justify-end">
//                     <button className={`px-6 py-3 rounded-full font-medium ${darkMode ? 'bg-purple-600 hover:bg-purple-700' : 'bg-indigo-600 hover:bg-indigo-700'} text-white transition-colors duration-300`}>
//                       Schedule a Consultation
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         )}
        
//         {/* ABOUT */}
//         {currentSection === 'about' && (
//           <section className="py-10">
//             <div className="container mx-auto px-4">
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//                 <div>
//                   <div className="relative">
//                     <div className={`absolute inset-0 ${darkMode ? 'bg-purple-900/30' : 'bg-indigo-100'} rounded-3xl -m-4 transform rotate-3`}></div>
//                     <div className={`relative ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-3xl p-6 shadow-xl transition-colors duration-300`}>
//                       <div className="aspect-w-16 aspect-h-9 mb-6">
//                         <div className="w-full h-64 bg-gray-300 rounded-xl overflow-hidden">
//                           <img src="/api/placeholder/600/400" alt="Team" className="w-full h-full object-cover" />
//                         </div>
//                       </div>
//                       <h3 className={`text-2xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Our Story</h3>
//                       <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-4`}>
//                         Founded in 2010, Cipher Accounting Solutions began with a mission to demystify finance and empower businesses through strategic financial guidance.
//                       </p>
//                       <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                         Over the years, we've grown from a small practice to a comprehensive financial services firm, but our commitment to personalized service has never wavered.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
                
//                 <div>
//                   <h2 className={`text-3xl lg:text-4xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
//                     Who We Are
//                   </h2>
//                   <p className={`text-lg mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                     We're not just accountants – we're strategic partners in your financial journey. Our team combines technical expertise with a deep understanding of business dynamics to provide solutions that drive real value.
//                   </p>
                  
//                   <div className={`mb-8 p-4 border-l-4 ${darkMode ? 'border-purple-600 bg-gray-800' : 'border-indigo-600 bg-gray-50'} rounded-r-lg transition-colors duration-300`}>
//                     <p className={`italic ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//                       "Our mission is to transform complex financial data into actionable insights that empower our clients to make confident decisions about their future."
//                     </p>
//                   </div>
                  
//                   <div className="space-y-4">
//                     {[
//                       {
//                         title: 'Client-Centered Approach',
//                         description: 'We prioritize understanding your unique needs and goals to deliver tailored solutions.'
//                       },
//                       {
//                         title: 'Forward-Thinking Strategies',
//                         description: 'We look beyond the numbers to identify opportunities and mitigate risks.'
//                       },
//                       {
//                         title: 'Integrity & Transparency',
//                         description: 'We maintain the highest ethical standards in all our client relationships.'
//                       }
//                     ].map((value, index) => (
//                       <div key={index} className="flex">
//                         <div className={`flex-shrink-0 h-6 w-6 mt-1 ${darkMode ? 'text-purple-500' : 'text-indigo-600'}`}>
//                           <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                           </svg>
//                         </div>
//                         <div className="ml-4">
//                           <h4 className={`text-lg font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{value.title}</h4>
//                           <p className={`${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{value.description}</p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
              
//               <div className="mt-16">
//                 <h3 className={`text-2xl font-bold mb-8 text-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>Our Leadership Team</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                   {[
//                     {
//                       name: 'Sarah Chen',
//                       title: 'Founder & CEO',
//                       bio: 'With over 20 years in financial services, Sarah leads our strategic vision.'
//                     },
//                     {
//                       name: 'Michael Rodriguez',
//                       title: 'Chief Financial Strategist',
//                       bio: 'Michael specializes in complex tax planning and financial forecasting.'
//                     },
//                     {
//                       name: 'Aisha Patel',
//                       title: 'Head of Client Relations',
//                       bio: 'Aisha ensures our services exceed client expectations at every turn.'
//                     }
//                   ].map((person, index) => (
//                     <div key={index} className={`group ${darkMode ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'} rounded-2xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl`}>
//                       <div className="flex flex-col items-center text-center">
//                         <div className={`w-24 h-24 rounded-full mb-4 overflow-hidden ${darkMode ? 'ring-2 ring-purple-600' : 'ring-2 ring-indigo-600'}`}>
//                           <img src="/api/placeholder/200/200" alt={person.name} className="w-full h-full object-cover" />
//                         </div>
//                         <h4 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{person.name}</h4>
//                         <p className={`${darkMode ? 'text-purple-400' : 'text-indigo-600'} mb-2`}>{person.title}</p>
//                         <p className={`${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{person.bio}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </section>
//         )}
        
//       </main>
//       </div>
//   )
// }

// export default HomePage

import React from 'react';
import hero1 from '../assets/heronew.png'
import team1 from '../assets/team1.jpg'
import team2 from '../assets/team2.jpg'
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Top Bar */}
     <Header />
      {/* Hero Section */}
      <div className="flex-grow bg-gradient-to-l from-customBlueLight to-customBlueDark text-white">
        <div className="container mx-auto px-6 py-20 flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0">
            <p className="text-lg mb-4">We'll help you thrive</p>
            <h1 className="text-5xl font-bold mb-8 leading-tight">
              The accountants<br />
              you've always<br />
              dreamed of
            </h1>
            <button className="bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-full inline-flex items-center">
            <Link to="/contact" className="block w-full h-full">Let's Get Started</Link>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </button>
          </div>
          <div className="w-auto md:w-1/2 flex justify-center">
            <img src={hero1} alt="Professional accountant" className="h-auto md:max-w-xl" />
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: 'Cost Accounting', icon: 'calculator' },
              { title: 'Tax Planning', icon: 'document' },
              { title: 'Financial Consulting', icon: 'chart' },
              { title: 'Audit Services', icon: 'checkmark' },
              { title: 'Bookkeeping', icon: 'book' },
              { title: 'Business Advisory', icon: 'lightbulb' }
            ].map((service, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-customBlueLight" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">Professional {service.title.toLowerCase()} services tailored to your business needs.</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <img src={team2} alt="Our team" className="rounded-lg shadow-md" />
            </div>
            <div className="md:w-1/2 md:pl-12">
              <h2 className="text-3xl font-bold mb-6">About Devang Patel & Associates</h2>
              <p className="text-gray-700 mb-6">
                Devang Patel & Associates is a leading cost accounting firm with over years of experience providing expert accounting services to businesses across India. Our team of certified accountants is dedicated to helping your business thrive through strategic financial planning and management.
              </p>
            
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">What Our Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3].map((item) => (
              <div key={item} className="bg-gray-50 p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="text-yellow-400 flex">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg key={star} className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 mb-4">
                  "Devang Patel & Associates has been instrumental in streamlining our accounting processes. Their expert advice has helped us optimize our financial operations and save significantly on taxes."
                </p>
                {/* <div className="flex items-center">
                  <div className="w-10 h-10 bg-gray-300 rounded-full mr-4"></div>
                  <div>
                    <h4 className="font-semibold">Client Name</h4>
                    <p className="text-sm text-gray-600">CEO, Company Ltd.</p>
                  </div>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>

  {/* Contact Section */}
<div className="bg-customBlueLight text-white py-16">
  <div className="container mx-auto px-6 text-center">
    <h2 className="text-3xl font-bold mb-8">Ready to work with us?</h2>
    <p className="text-xl mb-8 max-w-2xl mx-auto">
      Contact us today for a free consultation and discover how we can help your business grow.
    </p>
    
    <button className="bg-white text-customBlueLight hover:bg-gray-100 px-8 py-3 rounded-full font-semibold">
      <Link to="/contact" className="block w-full h-full">Contact Us Now</Link>
    </button>
    
  </div>
</div>


      {/* Footer */}
     <Footer />
    </div>
  );
};

export default HomePage;